export const ARCHIVE_FLEET_ENABLED = true;
export const GROUP_COMPARE_ENABLED = true;
export const YEAR_VIEW_ENABLED = true;
export const MILEAGE_GAUGE_ENABLED = false;
export const DISPLAY_NOTIFICATION = false;
export const SUPPORT_DEFAULT_TIMESPAN = "1 week";
export const TOP_ALERTS_ENABLED = true;
export const JOURNEY_SUPPORT_VIEW_PDF_EXPORT_ENABLED = false;
